export const CustomerBusinessPartnerPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">거래처 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">검색어</label>
                            <select className="form-select">
                                <option>이름</option>
                            </select>
                            <input type="text"
                                className="form-control"
                            />
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                        </div>
                    </div>
                    <div className="col-6">
                    </div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">거래처 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>
                        <button className="btn btn-primary w-100px px-0 ms-40px">거래처 생성</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th style={{ width: "4%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th style={{ width: "19.2%" }}>소속분류</th>
                                <th style={{ width: "19.2%" }}>산업구분​</th>
                                <th style={{ width: "24.2%" }}>회사명​</th>
                                <th style={{ width: "14.2%" }}>기본 연락처​</th>
                                <th>담당자​</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (
                                <tr>
                                    <td style={{ width: "2.85%" }}>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center">중견기업</td>
                                    <td className="text-center">IT</td>
                                    <td className="text-center">MDS 테크</td>
                                    <td className="text-center">010-1234-5678</td>
                                    <td className="text-center">홍길동</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}